<mat-card class="padding all margin all">
  <mat-card-header class="header-container padding all">
    <mat-card-title>Key System: {{ keySystem?.topMasterKeyName || 'N/A' }}</mat-card-title>
    <div *ngIf="!editing" class="row flex-end center">
      <button class="small-icon-button" (click)="toggleEdit()" mat-icon-button [disabled]="isReadOnly">
        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
      </button>

      <button *ngIf="expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
        <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
      </button>
      <button *ngIf="!expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
        <mat-icon fontSet="material-icons-outlined">expand_less </mat-icon>
      </button>
    </div>

    <div *ngIf="editing" class="row flex-end center">
      <button mat-stroked-button (click)="toggleEdit()" class="margin left">Close</button>

      <button
        mat-flat-button
        (click)="saveKeySystem()"
        class="save-button margin left"
        [disabled]="!editKeySystemForm.valid"
      >
        Save
      </button>
    </div>
  </mat-card-header>
  <mat-divider></mat-divider>

  <div class="card-form padding lg bottom" *ngIf="editing">
    <div class="col">
      <form [formGroup]="editKeySystemForm" autocompete="off">
        <div class="row">
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm left">
            <mat-label
              for="constructionKeyType"
              [ngClass]="{
                'error-message': fieldHasError(editKeySystemForm, 'constructionKeyType'),
                focus: focus.constructionKeyType
              }"
            >
              Construction Key Type
            </mat-label>

            <mat-select
              [ngClass]="{
                error: fieldHasError(editKeySystemForm, 'constructionKeyType'),
                disabled: constructionKeyDisabled(),
                'focus-border': focus.constructionKeyType
              }"
              (focus)="focusOn('constructionKeyType')"
              (focusout)="focusOn('constructionKeyType')"
              [disabled]="constructionKeyDisabled()"
              matNativeControl
              class="max-width"
              formControlName="constructionKeyType"
              [(value)]="selectedConstructionKeyType"
            >
              <mat-option
                *ngFor="let constructionKeyType of availableConstructionKeyTypes"
                [disabled]="constructionKeyDisabled()"
                [value]="constructionKeyType"
              >
                {{ constructionKeyType.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field floatLabel="always" appearance="outline" class="margin sm left">
            <mat-label
              for="orderId"
              [ngClass]="{
                'error-message': fieldHasError(editKeySystemForm, 'orderId'),
                focus: focus.orderId
              }"
            >
              Original Order
            </mat-label>

            <div class="row max-width">
              <input
                id="name"
                placeholder="Enter Order Number"
                [ngClass]="{
                  error: fieldHasError(editKeySystemForm, 'orderId'),
                  'focus-border': focus.orderId
                }"
                formControlName="orderId"
                (focus)="focusOn('orderId')"
                (focusout)="focusOn('orderId')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="orderId"
                autofocus
                (change)="updateOrderNumber()"
                [(value)]="keySystemOrderNumber"
              />

              <mat-icon *ngIf="fieldHasError(editKeySystemForm, 'orderId')" [size]="24" class="error-icon"
                >warning
              </mat-icon>
            </div>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.orderId">
              <div
                class="caption error-message margin lrg top"
                *ngIf="fieldHasErrorMessages(editKeySystemForm, validation, 'orderId')"
                id="keysErrors"
              >
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>

  <mat-card-content *ngIf="expanded" class="padding lrg all">
    <div class="row">
      <div class="col one-third-width">
        <div class="custom">Construction Key Type</div>
        <div class="data">
          {{ constructionKeyType?.description || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom">Original Order</div>
        <div class="data">
          {{ keySystem?.orderNumber || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom">Created By</div>
        <div class="data">
          {{ keySystem?.createdBy || 'N/A' }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col one-third-width">
        <div class="custom padding top">Last Modified By</div>
        <div class="data">
          {{ keySystem?.modifiedBy || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom padding top">Modified Date</div>
        <div class="data">
          {{ keySystem?.modifiedOn | date : 'M/d/yyyy' || 'N/A' }}
        </div>
      </div>
      <div class="col one-third-width">
        <div class="custom padding top">Created Date</div>
        <div class="data">
          {{ keySystem?.createdOn | date : 'M/d/yyyy' || 'N/A' }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col one-third-width">
        <div class="custom padding top">Has SL Product</div>
        <div class="data">
          {{ hasSlOrder ? 'Yes' : 'No' }}
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
